import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface HomepageSlide {
  id: number;
  type: 'image' | 'video';
  duration: number;
  media_url: string | null;
  poster_url: string | null;
  title: string | null;
  subtitle: string | null;
  description: string | null;
  button: {
    text: string | null;
    image_url: string | null;
    link: string | null;
    target: '_self' | '_blank';
    alt: string | null;
  } | null;
}

export interface HomepageSlidesResponse {
  data: HomepageSlide[];
  meta: {
    cached_at: string;
    locale: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class HomepageSlidesService {
  constructor(private http: HttpClient) {}

  /**
   * Get homepage slides for a specific locale
   * @param locale The language code (e.g., 'en', 'ar', 'fr', 'es')
   * @returns Observable of homepage slides response
   */
  getSlides(locale: string = 'en'): Observable<HomepageSlidesResponse> {
    return this.http.get<HomepageSlidesResponse>(
      `${environment.url}/main-website-general/homepage/slides`,
      {
        params: { locale },
      }
    );
  }
}
